export default {"src":"/_next/static/media/Refdocs_Logo_ColourWhite_SVG.3b265613.svg","height":203,"width":1000,"blurWidth":0,"blurHeight":0};